export default {
  title: 'Borde',
  count_one: '{{count}} bord',
  count_other: '{{count}} borde',
  filtered_count: '{{shown}} af {{count}} borde',
  intro:
    'Hvert bord har sit eget link og sin egen QR-kode. Gæster, der scanner den, bestiller til det bord, og du ser bordet på hver ordre.',
  migrated: {
    title: 'Room/Table service er nu Bordbestilling',
    description:
      'Vi har tilføjet et bord for hver af dine lokationer, opkaldt efter den, så gæster kan blive ved med at bestille. Omdøb dem, så de passer til dine borde, eller tilføj flere.',
  },
  add: {
    label: 'Tilføj et bord',
    placeholder: 'fx 7, 1A eller Terrasse 2',
    button: 'Tilføj bord',
  },
  errors: {
    empty: 'Indtast et bordnavn.',
    duplicate: 'Der findes allerede et bord med navnet »{{name}}«.',
    too_long: 'Et bordnavn kan højst have {{max}} tegn.',
  },
  columns: {
    order: 'Rækkefølge',
    table: 'Bord og link',
    on: 'Til',
    copy: 'Kopiér link',
    qr: 'QR-kode',
    actions: 'Handlinger',
  },
  switch: {
    on: 'Til',
    off: 'Fra',
  },
  buttons: {
    copy: 'Kopiér link',
    copied: 'Kopieret',
    download_qr: 'Download QR-kode',
    qr_short: 'QR-kode',
    rename: 'Omdøb',
    delete: 'Slet',
    save: 'Gem',
    cancel: 'Annuller',
  },
  aria: {
    move: 'Flyt {{name}} (piletaster)',
    switch: '{{name}} til',
    copy: 'Kopiér link til {{name}}',
    copied: 'Link kopieret',
    download_qr: 'Download QR-kode til {{name}}',
    rename: 'Omdøb {{name}}',
    delete: 'Slet {{name}}',
    more: 'Mere for {{name}}',
    new_name: 'Nyt navn til {{name}}',
  },
  tooltips: {
    move: 'Træk for at ændre rækkefølge',
    move_disabled: 'Ryd søgningen for at ændre rækkefølge',
  },
  rename_hint: 'Linket og QR-koden forbliver de samme.',
  no_link: 'Ingen shopadresse endnu',
  search: {
    placeholder: 'Søg i borde',
    no_results: 'Intet bord med navnet »{{text}}«.',
  },
  load_failed: {
    title: 'Bordene kunne ikke indlæses.',
    retry: 'Prøv igen',
  },
  empty: {
    title: 'Ingen borde endnu',
    text: 'Tilføj dine borde ovenfor for at få et link og en QR-kode til hver. Gæster kan ikke bestille ved et bord, før du har tilføjet et.',
  },
  delete: {
    title: 'Slet bord »{{name}}«?',
    warning:
      'Udskrevne QR-koder til dette bord holder op med at virke. Gæster, der scanner en, bliver bedt om at spørge personalet.',
    softer: 'Hvis du vil stoppe bestillinger ved dette bord i en periode, så slå det fra i stedet.',
    confirm: 'Slet bord',
    cancel: 'Annuller',
  },
  announcements: {
    moved: '»{{name}}« flyttet til position {{position}} af {{count}}.',
    instructions: 'For at flytte et bord skal du fokusere på dets håndtag og trykke på pil op eller pil ned.',
  },
  qr_image: {
    table: 'Bord',
  },
  toasts: {
    added: 'Bord »{{name}}« tilføjet',
    renamed: '»{{old}}« omdøbt til »{{name}}«',
    deleted: 'Bord »{{name}}« slettet',
    switched_on: '»{{name}}« slået til',
    switched_off: '»{{name}}« slået fra',
    failed_to_save: 'Det blev ikke gemt. Prøv igen.',
    failed_to_reorder: 'Den nye rækkefølge blev ikke gemt. Prøv igen.',
    failed_to_download_qr: 'QR-koden kunne ikke gemmes. Prøv igen.',
    copy_failed: 'Linket kunne ikke kopieres. Prøv igen.',
  },
};
